import { Checkbox } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import ProfileBloc from "../../../../bloc/profile_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import Base_screen from "../../base/base_screen/base_screen";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";

import "./proposal_form.css";
import AppTextField from "../../../component/app_text_field/app_text_field";
import AppSelectField from "../../../component/app_select_field/app_select_field";
import UtilBloc from "../../../../bloc/util_bloc";
import AppModal from "../../../component/app_modal/app_modal";
import { ReactComponent as InfoIcon } from "../../../../Info.svg";
import FormsBloc from "../../../../bloc/forms_bloc";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import { isContainNumberOnly, nameValidation, numberValidation } from "../../../component/app_validation";

class DirectCreditDetails extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.containerRef = React.createRef();
        this.contentRef = React.createRef();
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            directCreditData: {
                accHolderName: null,
                bankAccNo: null,
                bankName: null,
                isTermsAndConditionChecked: false,
            },
            bankList: null,
            termsConditionOpen: false,
            termsConditionViewed: false,
            errorMessage: 'Fill in the required field.',
            isTermsConditionScrollToEnd: false,
            checkScrollable: false
        };
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    setPropValue = () => {
        let valueobj = this.state.directCreditData;
        this.props.onChange(valueobj);
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
        this.getFormData();
    }

    initiateData() {
        let formData = this.props.value;
        let stateData = this.state.directCreditData;
        formData && Object.keys(formData).map(function (key) {
            stateData[key] = formData[key];
        })
        this.setState({ directCreditData: stateData }, () => {
            if (!UtilBloc.isNullOrEmpty(this.state.directCreditData.accHolderName) && !UtilBloc.isNullOrEmpty(this.state.directCreditData.bankAccNo) && !UtilBloc.isNullOrEmpty(this.state.directCreditData.bankName)) {
                this.handleValuehange('isTermsAndConditionChecked', true);
            }
        })
    }
    async getFormData() {
        this.setState({ loading: true });
        let bankList = await FormsBloc.getBankList();
        this.setState({
            bankList: bankList.data,
            loading: false
        });
    }

    getFormFields() {
        return this.props.fields;
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight <= 3;
        if (bottom) {
            this.handleValuehange('isTermsAndConditionChecked', true);
            this.setState({ termsConditionViewed: true });
        }
    }

    onValidateForm = () => {
        const { directCreditData } = this.state;
        let validated = true;
        Object.keys(directCreditData).map(function (key) {
            if (key == 'bankAccNo') {
                validated = validated && ((UtilBloc.isContainNumberOnly(directCreditData[key]) && directCreditData[key]?.length >= 7) || false);
            } else if (key == 'accHolderName') {
                validated = validated && (!UtilBloc.nameValidation(directCreditData[key]) || false);
            }
            else {
                validated = validated && (!UtilBloc.isNullOrEmpty(directCreditData[key]) || false);
            }
        });
        this.setPropValidation(validated);
        this.setPropValue();
        return validated;
    }

    setPropValidation = (result) => {
        this.props.handleValidationResult(result);
    }

    handleValuehange = (field, val) => {
        let data = this.state.directCreditData;
        data[field] = val
        this.setState({ personalDetailsData: data });
        this.onValidateForm();
    }

    handleNameChange(val) {
        this.setState({ name: val })
    }
    handleBankAccNoChange(val) {
        this.setState({ bankAccNo: val })
    }
    handleBankNameChange(val) {
        this.setState({ bankName: val })
    }

    handleTermsAndCondition(val) {
        if (this.state.termsConditionViewed == true) {
            this.handleValuehange('isTermsAndConditionChecked', val);
        } else {
            this.handleValuehange('isTermsAndConditionChecked', null);
        }
    }

    async handleFormSubmit() {

    }


    bankName() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.directCreditFormTitle.bankName}
                value={this.state.directCreditData.bankName}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                placeholder={'Select bank name...'}
                options={this.state.bankList}
                onChange={(e) => { this.handleValuehange(this.getFormFields().bankName, e) }}
            />
        )
    }

    bankAccNo() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.directCreditFormTitle.bankAccNo}
                type={'text'}
                placeholder={'Enter bank account number...'}
                value={this.state.directCreditData.bankAccNo}
                onValidate={(value) => { return (!UtilBloc.isContainNumberOnly(value) || value?.length < 7) }}
                errorMessage={numberValidation(this.state.directCreditData.bankAccNo) || 'Please enter a valid bank account number.'}
                onChange={(e) => { this.handleValuehange(this.getFormFields().bankAccNo, e) }}
            />
        )
    }

    name() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.directCreditFormTitle.accountHolderName}
                type={'text'}
                placeholder={'Enter account holder’s name...'}
                value={this.state.directCreditData.accHolderName}
                onValidate={(value) => { return UtilBloc.nameValidation(value) }}
                errorMessage={nameValidation(this.state.directCreditData.accHolderName)}
                onChange={(e) => this.handleValuehange(this.getFormFields().accHolderName, e)}
            />
        )
    }

    termAndCondition() {
        return (
            <div className="mt-3">
                <Checkbox onChange={(e) => this.handleTermsAndCondition(e.target.checked)} checked={this.state.directCreditData.isTermsAndConditionChecked}>
                    I have read the
                    <span
                        style={{ color: '#EE7623', cursor: 'pointer' }}
                        onClick={(e) => { e.stopPropagation(); this.setState({ termsConditionOpen: true }) }}>
                        {' '}Direct Credit Terms and Conditions
                    </span>.
                </Checkbox>
            </div>
        )
    }

    renderTermsAndConditionContent = () => {
        return (
            <>
                <div className="mt-4 px-3" style={{ height: '50vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} ref={this.containerRef}>
                    <div ref={this.contentRef} style={{ height: '65vh' }}>
                        <div className="quotation_privacy_policy_container d-flex">
                            <span className="quotation_privacy_policy_title">Direct Credit Terms and Conditions</span>
                        </div>
                        <div className='p-3'>
                            In consideration of FWD Takaful’s agreement to accept my authorisation to credit my bank account to receive monies payable to me under the given Takaful Certificate number(s), I expressly agree to the following terms and conditions:
                            <ol className="mt-3">
                                <li className="mt-3">
                                    FWD Takaful to use this bank account for the types of payments due to me, unless FWD Takaful receives a written instruction to revoke this instruction and provide the new Direct Credit details which must be approved by FWD Takaful prior to the payment effective date.
                                </li>
                                <li className="mt-3">
                                    I hereby agree to keep FWD Takaful indemnified against any claims, loss, damage and expenses which FWD Takaful may suffer arising from my authorisation to credit my bank account as aforesaid.
                                </li>
                                <li className="mt-3">
                                    I understand that the Direct Credit facility is only allowed for a valid bank account with a licensed financial institution in Malaysia that participates in the Interbank Giro (IBG) payment platform and I will provide my Direct Credit details to fulfil this condition.
                                </li>
                                <li className="mt-3">
                                    I understand that all or a portion of the Takaful Contribution(s), charges and payments for this Application may be subjected to the to the prevailing government tax rate (if applicable), which must be paid.
                                </li>
                                <li className="mt-3">
                                    Any fee(s) imposed by the bank for this service shall be fully borne by me.
                                </li>
                                <li className="mt-3">
                                    I understand that the Direct Credit instruction shall remain binding until FWD Takaful’s receipt of a written notification from me to cancel the instruction.
                                </li>
                                <li className="mt-3">
                                    I hereby agree that FWD Takaful shall not be held responsible for any loss due to the wrong banking account provided by me for the purpose of payment of the Takaful Certificate.
                                </li>
                                <li className="mt-3">
                                    Within a reasonable period, FWD Takaful shall provide a written notice:
                                    <ol type="a">
                                        <li className="mt-3" >
                                            To discontinue, interrupt, withdraw or suspend this service as it deems fit and FWD Takaful is not to be held liable for any loss or damage which may be suffered by me as a result of such action by FWD Takaful.
                                        </li>
                                        <li className="mt-3" >
                                            To add, delete or amend any of the above terms and conditions from time to time. Such amendments shall become effective on such date as FWD Takaful may elect to adopt and the continued use of this service by me shall constitute my acceptance of the said amendments.
                                        </li>
                                        <li className="mt-3">
                                            To hold monies pursuant to the Takaful Certificate related payment due to me in the event the information provided above is incorrect, incomplete and/or otherwise not possible due to no fault of FWD Takaful to successfully process this request until the new Direct Credit detail is received from me.
                                        </li>
                                    </ol>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <span style={{ color: '#9599B6', fontStyle: 'italic', fontSize: '14px' }}>This is an optional section</span>
                {this.state.loading && this.loadingContent()}
                <div className="w-100" >
                    <div className="d-flex mt-4 p-3 notice_container">
                        <InfoIcon />
                        <div className="ml-3">
                            <div className="notice_header">Important Notice</div>
                            <div className="notice_instruction mt-2">
                                Direct Credit account holder MUST be the Person to be Covered on the certificate. Direct Credit will only be applicable in the event where payment is to be made to the Person to be Covered.
                            </div>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.name()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.bankAccNo()}
                            </div>
                        </div>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.bankName()}
                            </div>
                        </div>
                        {this.termAndCondition()}
                    </div>
                    <AppModal
                        open={this.state.termsConditionOpen}
                        handleModalClose={() => this.setState({ termsConditionOpen: false })}
                        width={'70%'}
                        title={'Direct Credit Terms and Conditions'}
                        subtitle={'Last Updated on 30 Jan 2024'}
                    >
                        {this.renderTermsAndConditionContent()}
                    </AppModal>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(DirectCreditDetails));
